import axios from 'axios';
import { nationality } from 'utils/nationality';

export const getCountries = async () => {
  const url = 'https://countriesnow.space/api/v0.1/countries';
  let result = null;
  try {
    result = await axios.get(url);
  } catch (error) {
    result = error;
  }
  return result;
};

export const getCities = async (country: string) => {
  const url = 'https://countriesnow.space/api/v0.1/countries/cities';
  const requestBody = {
    country: country,
  };
  return await axios.post(url, requestBody);
};

export const getTimeZone = async () => {
  const res = await fetch('http://worldtimeapi.org/api/timezone');
  return res.json();
};

export const getNationality = () => {
  const uniqueNationalities = Array.from(
    new Set(nationality.map((item) => item.nationality)),
  );

  const res = uniqueNationalities.map((nationality) => {
    return {
      label: nationality,
      value: nationality,
    };
  });

  return res;
};
